module.exports = __webpack_public_path__ + "img/wave.feae4b5b.svg";